import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";

import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  IconButton,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {Link} from "react-router-dom";
import {changeRequestToggleState} from "../../Recoil/Atom/changeRequestState";
import * as changeRequestApi from "../../api/workOrderApi/changeRequestApi";
import MWSkeleton from "../../components/MWSkeleton";
import {useGetQuery} from "../../hooks/useQueryHooks";
import {ResponseList} from "../../models/clientModels/interfaces/Response";
import {
  EQChangeRequest,
  changeStatusNames,
  changeTypeNames,
  initializeChangeRequestListParams,
} from "../../models/serverModels/workOrder/EQChangeRequest";
import {StyledTable} from "../../styledComponents/StyledListContainer";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";

type ChangeRequestProp = {
  setValue: any;
  name: string;
};

const ChangeRequestPopup = ({setValue, name}: ChangeRequestProp) => {
  const tokenState = useRecoilValue(tokenSelector);
  const [changeRequestToggle, setChangeRequestToggle] = useRecoilState(changeRequestToggleState);

  const {
    data: changeRequestList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQChangeRequest>>({
    key: ["ChangeRequestList", {...initializeChangeRequestListParams, token: tokenState}],
    api: () => changeRequestApi.getList({...initializeChangeRequestListParams, token: tokenState}),
  });

  const handleClickOpen = () => {
    setChangeRequestToggle(true);
  };

  const handleClose = () => {
    setChangeRequestToggle(false);
  };

  // if (isLoading) {
  //   return <MWProgress />;
  // }

  return (
    <React.Fragment>
      <Dialog open={changeRequestToggle} onClose={handleClose} maxWidth="lg">
        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <i></i>
          <DialogTitle fontWeight={600}>변경 요청서</DialogTitle>
          <IconButton onClick={handleClose} aria-label="delete" sx={{marginRight: "16px"}}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{maxWidth: "100%"}}>
          <StyledTableContainer>
            <StyledTable>
              <StyledTableHead>
                <TableRow>
                  <TableCell align="center">#</TableCell>
                  <TableCell align="center">변경 No</TableCell>
                  <TableCell align="center">변경구분</TableCell>
                  <TableCell align="center">발의자</TableCell>
                  <TableCell align="center">발의부서</TableCell>
                  <TableCell align="center">변경내용</TableCell>
                  <TableCell align="center">변경등급</TableCell>
                  <TableCell align="center">단계</TableCell>
                  <TableCell align="center">서류첨부</TableCell>
                  <TableCell align="center">선택</TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {isLoading && isFetching ? (
                  <MWSkeleton row={12} column={10} />
                ) : (
                  changeRequestList?.items.map((item) => (
                    <TableRow key={item.uid}>
                      <TableCell align="center">
                        {item.uid}
                        {/* {page === 1
                      ? index + 1
                      : (page - 1) * changeRequestListParams.rows! + index + 1} */}
                      </TableCell>
                      <TableCell align="center">
                        <Link to={`/WorkOrder/EditChangeRequest/${item.uid}`}>
                          {item.serialString}
                        </Link>
                      </TableCell>
                      <TableCell align="left">
                        {changeTypeNames.find((v, idx) => (item.type === idx ? v : null))} <br />
                        {new Date(item?.completeDate).getFullYear()}년
                        {new Date(item?.completeDate).getMonth() + 1}월
                        {new Date(item?.completeDate).getDate()}일
                      </TableCell>
                      <TableCell align="center">{item.requester.name}</TableCell>

                      <TableCell align="center">{item.department.name}</TableCell>
                      <TableCell align="left">{item.content}</TableCell>
                      <TableCell align="center">{item.level}</TableCell>
                      <TableCell align="center">
                        {changeStatusNames.find((v, idx) => (item.status === idx ? v : null))}
                      </TableCell>
                      <TableCell align="left">
                        <Link to="">{item.attachmentFileName}</Link>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setValue(name, item);
                            setChangeRequestToggle(false);
                          }}
                        >
                          선택
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </StyledTable>
          </StyledTableContainer>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ChangeRequestPopup;
